import VueWrapper from '@/components/core/Vue/vue.wrapper';
import ClientFooterComponent from '@/components/vuetify/client-footer/client-footer.component';
import {PricingPlan} from '@/globals';
import {Component, Watch} from 'vue-property-decorator';

@Component({
    components: {
        ClientFooterComponent,
    },
})
export default class SubscriptionPlanComponent extends VueWrapper {
    exchangeRate: number = 1350;

    selectedPlanId: string | null = 'st500';

    includeCircuit: boolean = false;
    extraUsers: number = 0;

    readonly plans: PricingPlan[] = [
        {
            id: 'st200',
            name: 'St 200',
            equipmentLimit: 200,
            includedUsers: 5,
            priceUsd: 1,
            isEnterprise: false,
            features: ['Site Setup', 'Team Setup', 'Job Setup', 'Report', 'Analysis'],
        },
        {
            id: 'st500',
            name: 'St 500',
            equipmentLimit: 500,
            includedUsers: 5,
            priceUsd: 2400,
            isEnterprise: false,
            features: ['Site Setup', 'Team Setup', 'Job Setup', 'Report', 'Analysis'],
        },
        {
            id: 'st1000',
            name: 'St 1000',
            equipmentLimit: 1000,
            includedUsers: 5,
            priceUsd: 4000,
            isEnterprise: false,
            features: ['Site Setup', 'Team Setup', 'Job Setup', 'Report', 'Analysis'],
        },
        {
            id: 'enterprise',
            name: 'Enterprise',
            equipmentLimit: 'Unlimited',
            includedUsers: 0,
            priceUsd: 0,
            isEnterprise: true,
            features: ['All St Features', 'Custom Limits', 'Dedicated Support', 'Negotiable Add-ons'],
        },
    ];

    get currentPlan(): PricingPlan | undefined {
        return this.plans.find(p => p.id === this.selectedPlanId);
    }

    get isEnterpriseSelected(): boolean {
        return this.currentPlan?.isEnterprise || false;
    }

    get totalUsersCount(): number {
        if (!this.currentPlan || this.isEnterpriseSelected) return 0;
        const Base = this.currentPlan?.includedUsers ?? 0;
        const CircuitBonus = this.includeCircuit ? 2 : 0;
        return Base + CircuitBonus + this.extraUsers;
    }

    get subtotalUsd(): number {
        if (!this.currentPlan || this.isEnterpriseSelected) return 0;
        const planPrice = this.currentPlan.priceUsd;
        const circuitPrice = this.includeCircuit ? 500 : 0;
        return planPrice + circuitPrice;
    }

    get extraUserCostKrw(): number {
        return this.extraUsers * 30000;
    }

    get estimatedTotalKrw(): number {
        const usdToKrw = this.subtotalUsd * this.exchangeRate;
        return usdToKrw + this.extraUserCostKrw;
    }

    public mounted() {}

    formatPrice(value: number, currency: 'USD' | 'KRW'): string {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            maximumFractionDigits: 0,
        }).format(value);
    }

    selectPlan(planId: string) {
        this.selectedPlanId = planId;
        if (planId === 'enterprise') {
            this.includeCircuit = false;
            this.extraUsers = 0;
        }
    }

    @Watch('selectedPlanId')
    onPlanChange(newVal: string) {
        if (newVal === 'enterprise') {
            this.includeCircuit = false;
        }
    }

    proceedToCheckout() {
        if (!this.selectedPlanId || this.isEnterpriseSelected) {
            return;
        }

        const queryParams = {
            planId: this.selectedPlanId,
            includeCircuit: this.includeCircuit.toString(),
            extraUsers: this.extraUsers.toString(),
        };

        this.$router.push({
            name: 'Checkout',
            query: queryParams,
        });
    }
}
